module.exports = "<div *ngIf=\"page\">\n\n  <div *ngIf=\"page.acf\" class=\"theme-hero-image\" [style.background-image]=\"'url('+page.acf.hero_image?.url+')'\">\n  </div>\n\n</div>\n\n<div *ngIf=\"!page\">\n  <!--loading...-->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-home/page-home.component.html
// module id = ./src/app/pages/page-home/page-home.component.html
// module chunks = main